<!-- Modal de conversão de contato -->
<div class="modal" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'" tabindex="-1">
    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h3 class="modal-title fs-5">Dados da venda</h3>
                <button type="button" class="btn-close" (click)="closeModal(false)"></button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-12 col-md-3">
                        <div class="mb-3">
                            <label for="dataInicioVenda" class="form-label">Data de início</label>
                            <input type="date" class="form-control" id="dataInicioVenda"
                                [(ngModel)]="dataInicialFormatada">
                        </div>
                    </div>
                    <div class="col-12 col-md-3">
                        <div class="mb-3">
                            <label for="dataFinalVenda" class="form-label">Data final</label>
                            <input type="date" class="form-control" id="dataFinalVenda"
                                [(ngModel)]="dataFinalFormatada">
                        </div>
                    </div>
                    <div class="col-12 col-md-3">
                        <div class="mb-3">
                            <label for="parcelasVenda" class="form-label">Parcelas</label>
                            <input type="text" class="form-control" id="parcelasVenda" [value]="parcelas ?? 0"
                                (input)="formatarParcelasInput($event)" placeholder="0">
                        </div>
                    </div>
                    <div class="col-12 col-md-3">
                        <div class="mb-3">
                            <label for="valorTotalVenda" class="form-label">Valor total</label>
                            <input type="text" class="form-control" id="valorTotalVenda" [value]="valorTotalFormatado"
                                (input)="formatarValorTotalInput($event)" placeholder="R$ 0,00">
                        </div>
                    </div>
                    <div class="col-12 mt-3">
                        <div class="flex items-start gap-3">
                            <button class="text-brand-purple-300 text-lg" id="adicionarComentario">
                                <span class="material-symbols-outlined filled">edit</span>
                            </button>
                            <textarea placeholder="Observações adicionais" name=""
                                class="px-4 py-2 form-control resize-none text-base p-0 w-full" id="campoComentario"
                                [(ngModel)]="observacao"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer flex items-center justify-end gap-6">
                <button type="button" class="btn btn-secondary" (click)="closeModal(false)">Cancelar</button>
                <button [disabled]="processandoVenda" *ngIf="!ehRemoverVenda" type="button" class="btn btn-primary" (click)="converterContato()">Ok</button>
                <button [disabled]="processandoVenda" *ngIf="ehRemoverVenda" type="button" class="btn btn-danger" (click)="removerVenda()">Cancelar venda</button>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade" [class.show]="showModal" [style.display]="showModal ? 'block' : 'none'">
</div>

<aside class="sidebar-details p-6">
    <button class="btn-close-sidebar float-right" (click)="closeDetails()">
        <span class="sr-only">Fechar</span>
    </button>
    <app-carregando [showCarregando]="carregando" [isChart]="false" containerHeight="100vh" spinnerSize="40px">
    </app-carregando>
    <div *ngIf="!carregando && contato">
        <p class="text-brand-purple-300 font-medium text-sm">{{contato.nome ?? '-'}}</p>
        <div class="filtros-margens">
            <div *ngIf="margem == undefined" style="display: none;"
                [title]="permissaoService.hasPermission(EnumPermissao.ConsultarMargem) ? 'Consultar margem' : 'Você não tem permissão para consultar a margem'"
                [class.cursor-blocked]="!permissaoService.hasPermission(EnumPermissao.ConsultarMargem)">
                <button class="btn btn-primary my-4 h-10" (click)="consultarMargem()"
                    [disabled]="!permissaoService.hasPermission(EnumPermissao.ConsultarMargem)">
                    Consultar margem
                </button>
            </div>

            <div *ngIf="margem == false" style="display: none;">
                <button class="btn my-4  h-10" (click)="consultarMargem()">
                    <span class="badge rounded-pill text-bg-warning inline-flex items-center gap-1">
                        <span class="material-symbols-outlined">
                            percent
                        </span>
                        <span class="uppercase font-normal text-sm">
                            Sem margem
                        </span>
                    </span>
                </button>
            </div>

            <div *ngIf="margem == true" style="display: none;">
                <button class="btn my-4  h-10" (click)="consultarMargem()">
                    <span class="badge rounded-pill text-bg-info inline-flex items-center gap-1">
                        <span class="material-symbols-outlined">
                            percent
                    </span>
                    <span class="uppercase font-normal text-sm">
                        Com margem
                    </span>
                    </span>
                </button>
            </div>
        </div>
        <div class="space-y-4 text-sm">
            <p>{{contato.idade ?? '-' }} anos — {{contato.nascimento | formatarDataBR}}</p>
            <p>{{stringUtil.obterSexoPorExtenso(contato.sexo)}}</p>
            <p>{{contato.cidade ?? '-' }} - {{contato.uf ?? '-'}}</p>
            <div class="switch-container">
                <button *ngIf="contato.convertido" class="text-brand-purple-300 text-md mt-1"
                    id="editarContatoConvertido" (click)="abrirModalDadosVenda()">
                    <span class="material-symbols-outlined">edit_square</span>
                </button>
                <label class="switch">
                    <input type="checkbox" [(ngModel)]="contato.convertido" (change)="onContatoConvertidoChange($event)"/>                    
                    <span class="slider"></span>
                </label>
                <span class="switch-text">Convertido</span>
            </div>
        </div>
 
        <hr class="my-6">

        <div class="space-y-4  text-sm">
            <p class="font-medium text-sm text-brand-gray-400 opacity-50">Informações complementares</p>

            <ul class="space-y-4">
                <li class="grid grid-cols-12">
                    <span class="col-span-4">CPF</span>
                    <span class="col-span-8 font-medium">{{stringUtil.formatarCPF(contato.cpf ?? '-')}} ({{contato.uf
                        ?? '-' }})</span>
                </li>
                <li class="grid grid-cols-12">
                    <span class="col-span-4">RG</span>
                    <span class="col-span-8 font-medium">{{stringUtil.formatarRG(contato.rg ?? '-') }}</span>
                </li>
                <li class="grid grid-cols-12">
                    <span class="col-span-4">Renda</span>
                    <span class="col-span-8 font-medium">{{contato.renda ?? '-' }}</span>
                </li>
                <li class="grid grid-cols-12">
                    <span class="col-span-4">Situação</span>
                    <span class="col-span-8 font-medium">{{contato.situacaoCadastral ?? '-' }}</span>
                </li>
                <li class="grid grid-cols-12">
                    <span class="col-span-4">Persona</span>
                    <span class="col-span-8 font-medium">{{contato.geracao ?? '-' }}</span>
                </li>
                <li class="flex items-start gap-3">
                    <app-carregando [showCarregando]="processandoAnotacao" [isChart]="false"
                        spinnerSize="20px"></app-carregando>
                    <button class="text-brand-purple-300 text-lg" id="adicionarComentario" title="Salvar anotação"
                        (click)="salvarAnotacao()" *ngIf="!processandoAnotacao">
                        <span class="material-symbols-outlined filled">edit</span>
                    </button>
                    <textarea style="border: 1px solid #ccc; border-radius: 5px;"
                        class="resize-none text-base p-0 w-full" id="campoComentario"
                        [(ngModel)]="contato.anotacoes"></textarea>
                </li>
            </ul>
        </div>

        <hr class="my-6">

        <div class="space-y-4  text-sm">
            <p class="font-medium text-sm text-brand-gray-400 opacity-50">Dados de contato</p>
            <ul class="space-y-4 text-sm">
                <li class="flex items-center justify-between">
                    <span class="flex items-center gap-2">
                        {{stringUtil.formatarCelular(contato.cel1)}}
                        <img src="assets/img/whatsapp-icone.png" alt="" class="max-w-4" *ngIf="contato.whatsApp1">
                    </span>
                    <span class="font-semibold">{{contato.operadora1}}</span>
                </li>
                <li class="flex items-center justify-between" *ngIf="contato.cel2">
                    <span class="flex items-center gap-2">
                        {{stringUtil.formatarCelular(contato.cel2)}}
                        <img src="assets/img/whatsapp-icone.png" alt="" class="max-w-4" *ngIf="contato.whatsApp2">
                    </span>
                    <span class="font-semibold">{{contato.operadora2}}</span>
                </li>
                <li class="flex items-center justify-between" *ngIf="contato.email1">
                    <span>{{contato.email1}}</span>
                </li>
                <li class="flex items-center justify-between" *ngIf="contato.email2">
                    <span>{{contato.email2}}</span>
                </li>
            </ul>
        </div>

        <hr class="my-6">

        <div class="space-y-4 text-sm">
            <p class="font-medium text-sm text-brand-gray-400 opacity-50">Score de crédito</p>
            <ul class="space-y-4 text-sm">
                <li class="flex items-center justify-between">
                    <span>Score Digital</span>
                    <span class="font-semibold">{{contato.personaDigital ?? '-' }}</span>
                </li>
                <li class="flex items-center justify-between">
                    <span>Score NV</span>
                    <span class="font-semibold">{{contato.scoreNV ?? '-' }}</span>
                </li>
                <li class="flex items-center justify-between">
                    <span>Persona de crédito</span>
                    <span class="font-semibold">{{contato.score ?? '-' }}</span>
                </li>
                <li class="flex items-center justify-between">
                    <span>Persona demográfica</span>
                    <span class="font-semibold">{{contato.demografica ?? '-' }}</span>
                </li>
            </ul>
        </div>
    </div>
</aside>